import {FC, SVGProps} from 'react';

export const MyTaxAccessWarningIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="199" height="147" viewBox="0 0 199 147" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
		<path
			d="M192.69 132.042C190.976 133.122 188.929 133.767 186.647 133.767H34.5442C25.4078 133.767 20.0328 123.507 25.2186 115.995L101.27 5.89046C102.728 3.7872 104.72 2.37389 106.89 1.62829L106.812 1.517C106.656 1.27218 105.087 1.16089 104.831 1.29443L82.886 12.8791C81.0276 13.7582 79.4028 15.1159 78.1787 16.8965L2.13829 126.99C-0.421244 130.696 -0.699454 135.292 1.39269 139.276C3.48483 143.26 7.42428 145.641 11.9313 145.641L164.424 146.042C166.338 146.042 168.152 145.608 169.765 144.806L192.857 133.244C193.002 133.177 192.712 132.643 192.757 132.487C192.801 132.331 192.768 132.176 192.69 132.042Z"
			fill="black"
		/>
		<path d="M119.271 103.665H101.922V121.014H119.271V103.665Z" fill="black" />
		<path d="M119.271 26.8232H101.922V89.2091H119.271V26.8232Z" fill="black" />
		<path
			d="M25.2201 115.995L101.272 5.89093C105.779 -0.630312 115.416 -0.630312 119.923 5.89093L195.974 115.995C201.171 123.507 195.785 133.767 186.649 133.767H34.5457C25.4092 133.767 20.0342 123.507 25.2201 115.995V115.995Z"
			stroke="black"
			strokeWidth="2"
			strokeLinejoin="round"
		/>
	</svg>
);
